/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { isEmpty } from "lodash";
import React, { useEffect, useState } from "react";
import { getComents, createComent } from "../../apis/comment";

import systemAlert from "../../utils/systemAlert";
import { classnames } from "../../utils/text";
import DropzoneComponent from "../Dropzone";
import Loading from "../Loading";
import CommentItem from "./CommentItem";
import { useSelector } from "react-redux";


const Comment = ({
  className,
  postIdx,
  postType,
  submit,
  isFirstSubmit = true,
  isAnonymous,
  param = {},
  isReadCheck = false
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [comments, setComments] = useState([]);
  // TODO TOTAL 사용안함
  const [total, setTotal] = useState(0);

  const { employee } = useSelector((store) => ({
    employee: store.Profile.employee,
  }));

  const [uploadFiles, setUploadFiles] = useState([]);

  useEffect(() => {
    if (postIdx && postType) {
      _getComments();
    }
  }, [postIdx, postType]);

  const onFileChange = (files) => {
    setUploadFiles(files.files);
  };

  const reset = () => {
    setIsLoading(true);
    setTotal(0);
    _getComments();
  };

  const handleOnAddMemo = (content = "") => {
    if (!content && isEmpty(uploadFiles)) {
      systemAlert('내용과 첨부파일 둘중 하나는 필수입니다.');
      return;
    }

    setIsLoading(true);
    createComent({
      postIdx,
      postType,
      content,
      isAnonymous,
      param,
      ...isEmpty(uploadFiles) ? {} : { uploadFiles }
    }).then(() => {
      reset();
      if (submit) submit();
    }).catch(() => {
      setIsLoading(false);
    });
  };

  const _getComments = async () => {
    setComments([]);
    try {
      const comment = await getComents({
        postIdx, postType
      });
      setComments(comment.data.comments);
      setTotal(comment.data.total);
    } catch (error) {
      systemAlert('COMMENT DATA 호출 실패 : ' + JSON.stringify(error));
    }
    if (submit && isFirstSubmit) submit();
    setIsLoading(false);
  };

  return (
    isLoading ? <Loading></Loading> :
      <div className={classnames('comment-wrap', className)}>
        <div className='comment-list-wrap'>
          {comments.map((comment, idx) =>
            <CommentItem comment={comment} submit={_getComments} key={idx} isReadCheck={isReadCheck} employee={employee} />
          )}
        </div>
        <div className='comment-write-wrap print-out'>
          <DropzoneComponent
            onChange={onFileChange}
            isNoClick
            isMemo
            addTextAction={handleOnAddMemo}
          ></DropzoneComponent>
        </div>
      </div>
  );
};
export default Comment;
